import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register the required Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const EmployeesByPositionChart = ({ positions }) => {
  // Transform data to ensure minimum visibility for small values
  const transformedData = positions.map(p => {
    return {
      name: p.name,
      count: p.count < 5 ? 5 : p.count, // Set minimum value to 5 for visibility
      id: p.id_
    };
  });
  
  // Chart.js data structure
  const data = {
    labels: transformedData.map((p) => p.name),
    datasets: [
      {
        label: "Employees",
        data: transformedData.map((p) => p.count),
        backgroundColor: "#D3001A",
        borderRadius: 5,
        barPercentage: 0.9,
        // Adding a minimum height to bars
        minBarLength: 15,
      },
    ],
  };

  // Chart.js options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          title: (context) => context[0].label,
          label: (context) => {
            // Use original position data for tooltip to show actual values
            const position = positions[context.dataIndex];
            return `${position.name}: ${position.count} employees`;
          },
        },
        backgroundColor: '#333',
      },
      // Add datalabels configuration
      datalabels: {
        color: '#FFFFFF',
        font: {
          // weight: 'bold'
        },
        formatter: (value, context) => {
          // Display actual count instead of the transformed value
          return positions[context.dataIndex].count;
        }
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 8,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Employees",
        },
        beginAtZero: true,
        // Set a suggested maximum to improve visibility of small values
        suggestedMax: Math.max(...positions.map(p => p.count)) * 1.1,
        // Set a minimum visible value
        min: 0,
      },
    },
    // Add onClick handler for the chart
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const positionId = positions[index].id_;
        window.open(`/employees?position=${positionId}`, '_blank');
      }
    },
    // Change cursor to pointer when hovering over bars
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
    }
  };

  // Set minimum width to ensure scrolling when needed, based on number of data points
  const minChartWidth = Math.max(positions.length * 40, 300); // At least 40px per bar, minimum 300px

  return (
    <div style={{ 
      overflowX: 'auto',
      width: '100%',
      paddingTop: "10px"
    }}>
      <div style={{ 
        height: "290px", 
        minWidth: `${minChartWidth}px`
      }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default EmployeesByPositionChart;
